<template>
    <v-container v-if="isCreating">
        <v-card>
            <h2 class="text-center">Create New Session</h2>
            <v-progress-linear
                slot="progress"
                color="primary"
                indeterminate
                v-if="createdLoading"
            ></v-progress-linear>
            <v-row v-else>
                <v-col cols="12" md="6" offset-md="3">
                    <v-form
                        @submit.prevent
                        ref="editForm"
                        v-model="createSessionValid"
                    >
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    :items="species"
                                    item-text="SpeciesFullName"
                                    item-value="SpeciesID"
                                    v-model="newSession.SpeciesID"
                                    label="Species"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :items="activeRooms"
                                    item-text="Text"
                                    item-value="RoomID"
                                    v-model="newSession.RoomID"
                                    label="Room"
                                    :rules="[rules.selectIDRequired]"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :items="users"
                                    item-text="FullName"
                                    item-value="Email"
                                    label="Primary Extractor"
                                    v-model="currentPrimaryExtractor"
                                    :rules="[rules.required]"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    :items="users"
                                    item-text="FullName"
                                    item-value="Email"
                                    label="Assistant"
                                    v-model="currentAssistantExtractor"
                                    :rules="[rules.required]"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="newSession.RackNumber"
                                    label="Rack Number"
                                    counter="200"
                                    maxlength="200"
                                    :rules="[rules.required]"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" class="text-center">
                                <v-btn
                                    :disabled="!createSessionValid"
                                    color="accent"
                                    @click="createSession()"
                                >
                                    Create
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-card>
            <h2 class="text-center">
                {{
                    currentSession.IsClosed
                        ? "Daily Extraction Details"
                        : "Record Daily Extractions"
                }}
            </h2>
            <v-row no-gutters>
                <v-progress-linear
                    slot="progress"
                    color="primary"
                    indeterminate
                    v-if="loadingSession"
                ></v-progress-linear>
                <v-col cols="12" md="6" offset-md="3" v-else>
                    <v-row no-gutters>
                        <v-col cols="12" class="text-center">
                            <h3>{{currentSession.Barcode}}</h3>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Session Start </v-col>
                                <v-col cols="8" sm="9">
                                    {{
                                        currentSession.SessionStartTime
                                            | formatDate
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            v-if="currentSession.IsClosed"
                        >
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> By </v-col>
                                <v-col cols="8" sm="9">
                                    {{
                                        currentSession
                                            .SessionStartUserEmail
                                            | formatUserName(
                                                currentSession
                                                    .SessionStartUserFirstName,
                                                currentSession
                                                    .SessionStartUserLastName
                                            )
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            v-if="currentSession.IsClosed"
                        >
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Session End </v-col>
                                <v-col cols="8" sm="9">
                                    {{
                                        currentSession.SessionEndTime
                                            | formatDate
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="0" sm="0" md="6" v-else> </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            v-if="currentSession.IsClosed"
                        >
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> By </v-col>
                                <v-col cols="8" sm="9">
                                    {{
                                        currentSession.SessionEndUserEmail
                                            | formatUserName(
                                                currentSession
                                                    .SessionEndUserFirstName,
                                                currentSession
                                                    .SessionEndUserLastName
                                            )
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            v-if="currentSession.VenomRefrigerated"
                        >
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Venom Refrigerated At </v-col>
                                <v-col cols="8" sm="9">
                                    {{
                                        currentSession.VenomRefrigeratedTime
                                            | formatDate
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            md="6"
                            v-if="currentSession.VenomRefrigerated"
                        >
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> By </v-col>
                                <v-col cols="8" sm="9">
                                    {{
                                        currentSession.VenomRefrigeratedUser
                                            | formatUserName(
                                                currentSession
                                                    .VenomRefrigeratedUserFirstName,
                                                currentSession
                                                    .VenomRefrigeratedUserLastName
                                            )
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Species </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentSession.SpeciesFullName }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Room </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentSession.RoomName }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Rack </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentSession.RackNumber }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" v-if="currentSession.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Included in Monthly Pool? </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentSession.MonthlyPoolID ? "Yes" : "No" }}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" v-if="currentSession.IsClosed">
                            <v-row no-gutters>
                                <v-col cols="4" sm="3"> Comment </v-col>
                                <v-col cols="8" sm="9">
                                    {{ currentSession.Comment}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            class="text-center"
                            
                        >
                            <v-btn color="warning" @click="beginEndingSession" v-if="!endingSession && !currentSession.IsClosed" class="mr-2">
                                End Session
                            </v-btn>
                            <v-btn color="info" @click="exportDetails" :disabled="exporting" :loading="exporting">
                                Export
                            </v-btn>
                            <v-btn color="info" @click="print" class="ml-2">
                                Print
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>

        <v-card
            v-if="!loadingSession && !endingSession && !currentSession.IsClosed"
        >
            <v-row>
                <v-col cols="12" md="6" offset-md="3">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                :items="users"
                                item-text="FullName"
                                item-value="Email"
                                label="Primary Extractor"
                                v-model="currentPrimaryExtractor"
                                :rules="[rules.required]"
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :items="users"
                                item-text="FullName"
                                item-value="Email"
                                label="Assistant"
                                v-model="currentAssistantExtractor"
                                :rules="[rules.required]"
                            >
                                <template v-slot:append-outer>
                                    <v-icon @click="swapExtractors">mdi-swap-vertical-bold</v-icon>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field
                                label="Specimen ID"
                                v-model="enteredSpecimenID"
                                @keyup.native="checkEnterKey"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-row>
                                <v-col cols="12" class="mr-1">
                                    <v-btn
                                        block
                                        color="primary"
                                        :loading="loadingSpecimen"
                                        @click="loadSpecimen"
                                        :disabled="!canSearchSpecimen"
                                    >
                                        Go
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col sm="12" v-if="specimenSessionError">
                            <v-alert text type="error">{{ specimenSessionError }}</v-alert>
                        </v-col>
                        <DailyHusbandryExtractionForm ref="extractionEntryForm"
                            :dailyExtractionSession="currentSession"
                            :primaryExtractor="currentPrimaryExtractor"
                            :secondaryExtractor="currentAssistantExtractor"
                            @recorded="extractionRecorded">
                        </DailyHusbandryExtractionForm>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        <v-card v-if="!loadingSession && endingSession">
            <v-row>
                <v-col cols="12" md="6" offset-md="3">
                    <v-row>
                        <v-col sm="12" class="text-center">
                            <v-btn color="info" @click="printBarcode">
                                Print Barcode
                            </v-btn>
                        </v-col>
                        <v-col sm="12">
                            <NumericEntry
                                v-model="endSessionRequest.VenomVolumeML"
                                label="Venom Volume Collected"
                                :rules="[]"
                                suffix="mL"
                                :decimalPlaces="4"
                                :maxValue="10000"
                            >
                            </NumericEntry>
                        </v-col>
                        <v-col sm="12">
                        </v-col>
                        <v-col>
                            <v-textarea label="Comment" v-model="endSessionRequest.Comment" ></v-textarea>
                        </v-col>
                        <v-col sm="12" class="text-center">
                            <v-btn
                                color="accent"
                                :loading="loadingEndSession"
                                :disabled="!endSessionValid"
                                @click="showConfirmEndSession"
                            >
                                End Session
                            </v-btn>
                            <v-btn color="warning" @click="cancelEndSession" class="ml-2">
                                Cancel
                            </v-btn>
                        </v-col>
                        <v-col sm="12" v-if="endSessionError">
                            <v-alert text type="error">{{ endSessionError }}</v-alert>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
        <v-card v-if="!loadingSession" class="pa-0">
            <template>
                <v-row justify="center">
                    <v-dialog
                        v-model="deleteDialog"
                        persistent
                        max-width="290"
                    >
                        <v-card>
                            <v-card-text class="headline">
                                Are you sure you want to delete this record ?
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="accent"
                                    @click="deleteDialog = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    color="info"
                                    :loading="deleting"
                                    @click="deleteSessionRecord(deletedRecordID)"                                              
                                >
                                    Confirm
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="title text-center">Specimen Records</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-data-table
                            :headers="sessionHeaders"
                            :items="sessionEntries"
                            :loading="loadingSessionEntries"
                            :sort-by.sync="sessionPagination.sortBy"
                            :sort-desc.sync="sessionPagination.sortDesc"
                            :items-per-page.sync="sessionPagination.rowsPerPage"
                            :page.sync="sessionPagination.page"
                        >
                            <v-progress-linear
                                slot="progress"
                                color="primary"
                                indeterminate
                            ></v-progress-linear>
                            <template v-slot:item.RecordedAt="{ item }">
                                {{ item.RecordedAt | formatDate }}
                            </template>
                            <template v-slot:item.HusbandryPerformed="{ item }">
                                <v-icon color="success" v-if="item.HusbandryPerformed">check</v-icon>
                                <v-icon color="error" v-else>close</v-icon>
                            </template>
                            <template v-slot:item.VenomCollected="{ item }">
                                <v-icon color="success" v-if="item.VenomCollected">check</v-icon>
                                <v-icon color="error" v-else>close</v-icon>
                            </template>
                            <template v-slot:item.PrimaryExtractorEmail="{ item }">
                                {{ item.PrimaryExtractorEmail }}
                            </template>
                            <template v-slot:item.AssistantEmail="{ item }">
                                {{ item.AssistantEmail }}
                            </template>
                            <template v-slot:item.Delete="{ item }">
                                <v-btn
                                    color="accent"
                                    v-if="!currentSession.IsClosed && permission"
                                    @click="showDeleteDialog(item.DailyExtractionSessionEntryID)"
                                >
                                    Delete
                                </v-btn>
                            </template>
                            <template v-slot:item.Edit="{ item }">
                                <v-btn
                                    color="warning"
                                    v-if="!currentSession.IsClosed && permission"
                                    @click="loadSpecimenRecord(item.DailyExtractionSessionEntryID)"
                                >
                                    Edit
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="currentSession.IsClosed">
                    <v-expansion-panel-header>
                        <div class="title text-center">Venom Analysis</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <VenomAnalysis :dailyExtractionID="openSessionID"></VenomAnalysis>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>

        <EndDailyExtractionSession ref="endConfirmPopup" @confirmed="endSession"></EndDailyExtractionSession>

    </v-container>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import NumericEntry from "../common/NumericEntry";
import VenomAnalysis from '../venomanalysis/VenomAnalysis';
import DailyHusbandryExtractionForm from "@/components/venompooling/DailyHusbandryExtractionForm.vue"
import moment from "moment";
import util from "@/helpers/util";
import GlobalEventBus from "@/globalEventBus";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import * as VenomPoolingAPI from "@/services/venomPoolingAPI";
import constants from "comunet-btg-utah-repository-shared/constants";
import exports from "@/services/export";
import EndDailyExtractionSession from "./EndDailyExtractionSession";

export default {
    components: {
        NumericEntry,
        VenomAnalysis,
        DailyHusbandryExtractionForm,
        EndDailyExtractionSession
    },
    props: {
        openSessionID: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            rules: validationRules.rules,

            newSession: {}, // used in create mode
            createSessionValid: false,

            loadingSession: false,
            currentSession: {}, // Used in edit mode
            // Managing session, the current specimen
            enteredSpecimenID: null,
            loadingSpecimen: false,
            currentSpecimen: {},
            savingSpecimenSession: false,
            specimenSessionError: "",

            // Ending a session
            endingSession: false,
            endSessionError: "",
            loadingEndSession: false,
            endSessionRequest: {},

            // Session Entries
            loadingSessionEntries: false,
            sessionEntries: [],
            sessionHeaders: [
                {
                    text: "Specimen ID",
                    value: "SpecimenDisplayID",
                },
                {
                    text: "Geographical Location",
                    value: "GeographicalLocationName"
                },
                {
                    text: "Recorded At",
                    value: "RecordedAt",
                },
                {
                    text: "Primary Extractor",
                    value: "PrimaryExtractorEmail",
                },
                {
                    text: "Assistant",
                    value: "AssistantEmail",
                },
                {
                    text: "Husbandry Performed",
                    value: "HusbandryPerformed",
                },
                {
                    text: "Venom Collected",
                    value: "VenomCollected",
                },
                {
                    text: "Collection Comment",
                    value: "CollectionComment",
                },
                {
                    text: "",
                    value: "Delete",
                    sortable: false,
                },
                {
                    text: "",
                    value: "Edit",
                    sortable: false,
                },
                
            ],
            sessionPagination: {
                rowsPerPage: 10,
            },

            currentPrimaryExtractor: undefined,
            currentAssistantExtractor: undefined,

            exporting: false,

            deleteDialog: false,
            deletedRecordID:null,
            deleting:false
        };
    },
    computed: {
        ...mapGetters({
            activeRooms: "locationStore/activeRooms",
        }),
        ...mapState("locationStore", {
            rooms: (state) => state.rooms,
        }),
        isCreating() {
            return !(this.openSessionID && this.openSessionID > 0);
        },
        createdLoading() {
            return (
                this.$store.state.locationStore.loading ||
                this.$store.state.speciesStore.loading ||
                this.$store.state.userStore.loading
            );
        },
        canSearchSpecimen() {
            return this.currentPrimaryExtractor && this.currentPrimaryExtractor.length > 0 &&
                this.currentAssistantExtractor && this.currentAssistantExtractor.length > 0 &&
                this.enteredSpecimenID && this.enteredSpecimenID != "";
        },
        species() {
            return this.$store.state.speciesStore.species
                .filter((s) => s.Active)
                .sort(util.sortByField("SpeciesFullName"));
        },
        users() {
            return this.$store.state.userStore.dailyExtractionUsers.map((x) => {
                x.FullName =
                    x.FirstName != "" || x.LastName != ""
                        ? x.FirstName + " " + x.LastName + "(" + x.Email + ")"
                        : x.Email;
                return x;
            })
            .sort((a,b) => a.FullName.toLowerCase() > b.FullName.toLowerCase() ? 1 : -1)
        },
        specimenLoaded() {
            return (
                !this.loadingSpecimen &&
                this.currentSpecimen != null &&
                this.currentSpecimen.SpecimenID &&
                this.currentSpecimen.SpecimenID > 0
            );
        },
        
        endSessionValid() {
            return (
                this.endSessionRequest.VenomVolumeML &&
                this.endSessionRequest.VenomVolumeML > 0
            );
        },
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        },
    },
    methods: {
        async exportDetails() {
            this.exporting = true;

            await exports.exportDailyExtraction(this.openSessionID);
            
            this.exporting = false;
        },
        print() {
            let routeData = this.$router.resolve({name: 'printdailyextractionsession', params: { dailyExtractionSessionID: this.openSessionID }});
            window.open(routeData.href, '_blank');
        },
        processScan(scan) {
            if (scan.specimenDisplayID != "") {
                this.enteredSpecimenID = scan.specimenDisplayID;
                this.loadSpecimen();
            }
        },
        // Creates a new session and opens it for adding specimen entries
        async createSession() {

            //store the latest created room to local storage
            localStorage.setItem("latestRoomID",this.newSession.RoomID);
            // Set the current time
            this.newSession.SessionStartTime = moment().toDate();
            this.newSession.SessionDate = moment().format('YYYY-MM-DD');
            var result = await VenomPoolingAPI.createNewDailyExtractionSession(
                this.newSession
            );
            
            this.$router.replace(
                "/dailyextractionsession/" + result.DailyExtractionSessionID
            );

            this.openSessionID = result.DailyExtractionSessionID;

            this.loadSession();
        },
        checkEnterKey(event) {
            if (event.keyCode === 13) {
                this.loadSpecimen();
            }
        },
        loadSpecimenRecord(recordID){

            const currentRecord = this.sessionEntries.find(e=>e.DailyExtractionSessionEntryID == recordID );
            if(currentRecord.length == 0 || currentRecord.length > 1){
                return;
            }
            let that = this
            that.$refs.extractionEntryForm.showDialog(currentRecord,"UPDATE");

        },
        loadSpecimen() {
            if (!this.canSearchSpecimen) {
                return;
            }
            this.loadingSpecimen = true;
            this.currentSpecimen = {};
            this.specimenSessionError = "";

            let that = this;
            this.$store.dispatch("specimenStore/loadSpecimens", {
                params: {
                    SpecimenDisplayID: this.enteredSpecimenID,
                },
                success: (data) => {
                    if (!(data.TotalSpecimens != 1)) {
                        that.currentSpecimen = data.Specimens.map(function (l) {
                            var species = that.$store.state.speciesStore.species.find(
                                (x) => x.SpeciesID == l.SpeciesID
                            );
                            l.Species = species;

                            return l;
                        })[0];
                        if(data.disableDailyFromExtraction) {
                            this.specimenSessionError = "This Specimen has been flagged as rest from extraction";
                        } else {
                            // Show the dialog
                            const action = "INSERT"
                            that.$refs.extractionEntryForm.showDialog(that.currentSpecimen,action);
                        }
                    }
                },
                finally: () => {
                    that.loadingSpecimen = false;
                },
            });
        },
        setDefaultRoom(){
            const value = parseInt(localStorage.getItem("latestRoomID"));
            this.newSession.RoomID = value;
        },
        async loadSession() {
            this.loadingSession = true;
            this.currentSession = {};

            this.currentSession = await VenomPoolingAPI.getDailyExtractionSession(
                { dailyExtractionSessionID: this.openSessionID }
            );

            // Start loading the session entries and move on
            await this.loadSessionEntries();

            if (this.sessionEntries.length > 0) {
                var lastSession = this.sessionEntries[this.sessionEntries.length - 1];
                this.currentPrimaryExtractor = lastSession.PrimaryExtractorEmail;
                this.currentAssistantExtractor = lastSession.AssistantEmail;
            }

            this.loadingSession = false;
        },

        async deleteSessionRecord(recordID){
            try {
                this.deleting = true;
                const data = await VenomPoolingAPI.deleteDailyExtractionRecord(recordID);
                this.loadSessionEntries();
                this.deleteDialog = false;   
            } 
            catch (e) {
                this.specimenSessionError = e; 

            } 
            finally {
                this.specimenSessionError = "";
                this.deleting = false;
            }
        },
        
        showDeleteDialog(recordID){
            this.deletedRecordID = recordID;
            this.deleteDialog = true;
        },

        extractionRecorded() {
            this.enteredSpecimenID = "";
            this.currentSpecimen = {};
            this.loadSessionEntries();
        },

        beginEndingSession() {
            this.endingSession = true;
            this.endSessionRequest = {
                DailyExtractionSessionID: this.currentSession.DailyExtractionSessionID
            };
        },
        showConfirmEndSession() {
            this.$refs.endConfirmPopup.showDialog(this.currentSession.Barcode);
        },
        async endSession() {
            this.loadingEndSession = true;

            this.endSessionRequest.SessionEndTime = moment().toDate();
            var res = await VenomPoolingAPI.endDailyExtractionSession(
                this.endSessionRequest
            );

            if (res.sessionEnded) {
                this.$router.push({ name: "dailyextractions" });
            } else {
                this.endSessionError = res.reason;

                this.loadingEndSession = false;
            }
        },
        cancelEndSession() {
            this.endingSession = false;
        },
        printBarcode() {
            let routeData = this.$router.resolve({
                name: "printbarcode",
                params: { barcode: this.currentSession.Barcode },
            });
            window.open(routeData.href, "_blank");
        },
        async loadSessionEntries() {
            this.loadingSessionEntries = true;

            this.sessionEntries = await VenomPoolingAPI.getDailyExtractionSessionEntries(
                {
                    DailyExtractionSessionID: this.currentSession
                        .DailyExtractionSessionID,
                }
            );

            this.loadingSessionEntries = false;
        },
        swapExtractors() {
            var temp = this.currentPrimaryExtractor;
            this.currentPrimaryExtractor = this.currentAssistantExtractor;
            this.currentAssistantExtractor = temp;
        }
    },
    created() {
        this.setDefaultRoom();
        this.$store.dispatch("speciesStore/loadSpecies");
        this.$store.dispatch("userStore/loadDailyExtractionUsers");
        if (this.isCreating) {
            this.$store.dispatch("locationStore/loadRooms");
        } else {
            this.loadSession();
        }
        GlobalEventBus.$on("onScan", this.processScan);
    },
    beforeDestroy() {
        GlobalEventBus.$off("onScan", this.processScan);
    },
    filters: {
        formatDate: function (value) {
            var date = moment(value);
            if (date.isValid) {
                return date.format(constants.DATE_FORMAT);
            } else {
                return value;
            }
        },
          formatUserName(email, firstname, surname){
            
            if (!email){
                return "";
            }

            var desc = "";
            if (firstname && firstname != "") {
                desc = firstname;
            }

            if (surname && surname != "") {
                desc += (desc == "" ? "" : " ") + surname;
            }
            desc += (desc == "" ? "" : " (") + email + (desc == "" ? "" : ")")

            return desc;
        },
    },
};
</script>
<style scoped>
.specimen-warning {
    color: red;
}
</style>